import React, { useState, useEffect, useRef} from "react";
import "../App.css";


const services = [
  {
    title: "Badsanierung & Badgestaltung",
    desc:
      "Komplette Neugestaltung und Modernisierung von Bädern – von der Planung bis zur fertigen Fliesenarbeit.",
    icon: "🛁",
  },
  {
    title: "Fliesenverlegung",
    desc:
      "Professionelle Verlegung von Wand- und Bodenfliesen in allen Wohn- und Arbeitsbereichen.",
    icon: "🧱",
  },
  {
    title: "Naturstein- & Mosaikarbeiten",
    desc:
      "Verlegung von Naturstein, Mosaik und Feinsteinzeug für individuelle und hochwertige Oberflächen.",
    icon: "🪨",
  },
  {
    title: "Terrassen & Balkone",
    desc:
      "Fachgerechte Fliesenarbeiten im Außenbereich – wetterfest und langlebig für Terrassen und Balkone.",
    icon: "🏡",
  },
  {
    title: "Reparatur & Sanierung",
    desc:
      "Ausbesserung von beschädigten Fliesen, Silikonfugen und kleinere Sanierungsarbeiten.",
    icon: "🛠️",
  },
  
];

const Services = () => {
  const refs = useRef([]);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const onScroll = () => {
      refs.current.forEach((el, i) => {
        if (el && !visible[i]) {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight - 80) {
            setVisible(v => {
              const copy = [...v];
              copy[i] = true;
              return copy;
            });
          }
        }
      });
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [visible]);

  return (
    <>
      <section className="page-header">
         <h1>Unsere Leistungen</h1>
         <p>Qualität und Handwerk für Ihr Zuhause</p>
      </section>
      <section className="services-section" style={{position: "relative", overflow: "hidden"}}>
        
        {/* Removed internal H2 since we have a header now */}
        <div className="leistungen-list">
          {services.map((l, i) => (
            <div
              key={l.title}
              ref={el => refs.current[i] = el}
              className={`leistung-fadein${visible[i] ? " visible" : ""}`}
              style={{marginBottom: "5rem"}}
            >
              <h2 style={{color:"#ffa726"}}>{l.title}</h2>
              <p>{l.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
);
};

export default Services;